<template>
    <!-- <v-input :hint="hint" persistent-hint >
  
    </v-input> -->
<div :disabled="disable" :class="{ pasifCard: disable }">
     <div v-if="disable"  style="background: white;"><span style="color: red;">Bu öğe pasif olduğundan başvuru ekranında görüntülenmeyecektir. </span></div>
    <div>
        <div class="mb-1">
            <p> 
                    <strong v-html="label"> </strong>  <strong v-if="required" style="color: red;margin:0px 5px;">*</strong> 
                  </p>
        </div>
        <!-- <v-list-item-title class="text-h5 mb-1" v-for="item in items" :key="item.name">
            <v-checkbox v-model="value" :label="item.name" :rules="listRules" :value="item.name" ></v-checkbox>
        </v-list-item-title> -->
        <v-container>
            <v-row>
              
                <v-col    :cols="ayar.incols || 12"   class="ma-0 pa-0" v-for="item in items" :key="item.name">
                      <v-checkbox  v-model="value" :label="item.name" :rules="listRules" :value="item.name" ></v-checkbox>
                </v-col>
               
            </v-row>
        </v-container>
    <div>
           
    </div>
        
      
    </div>
</div>

<!-- <v-card :disabled="disable" :class="{ pasifCard: disable }"
  elevation="3"
>
  
 <v-card-text >
    
</v-card-text>
</v-card> -->


    <!-- <v-list-item>
            <v-list-item-content>
                <div class="mb-1">
                    {{ label }}
                </div>
           
             
                <v-list-item-subtitle> <span v-if="hint.length > 0">{{
                    hint }}</span></v-list-item-subtitle>
        
            </v-list-item-content>

        </v-list-item> -->
</template>
<script>
import { checkSF, textSF } from '@/plugins/FieldDataFormat.js'
import { rules } from '@/plugins/custom.js'
export default {
    data() {
        return {

            id: "",
            value: [],
            label: "",
            required: false,
            color: null,
            disable: false,
            hint: "",
            items: [],
     

            // rules: [v => !!v || 'Name is required'],
            placeholder: "",
            

        }
    },
    props: {
        ayar: {
            // default: '{"title":"","description":""}',
            default() {
                return checkSF;
            },
            type: Object
        },
        rules: {
            default() {
                return [v => !!v || 'Name is required'];
            },
            type: Array

        }

    },
    methods: {
        changeEvent(e) {

            if (this.trigger) {
                let values = this.store.
                    filter(m => {
                        let index = m.name.indexOf("::");
                        let value = m.name.substring(0, index);
                        return !value.localeCompare(e)
                    }).
                    map(item => {
                        let index = item.name.indexOf("::");
                        if (index > -1) {
                            let value = item.name.substring(index + 2, item.name.lenght);
                            return { id: value, name: value };
                        }
                        return item;
                    })
                this.$emit('triggerEvent', { id: this.triggerId, values })
            }
            else {
                return e;
            }


        },
        dataBind(json) {
            //console.log("Vtext Json", json);
            // let ayarJson = JSON.parse(jsonStr);
            this.title = json.title;

            // this.rules = json.rules;
            this.hint = json.hint;
            this.label = json.label;
            this.required = json.required;
            this.items = json.items;
this.disable=json.disable;
            this.id = json.id;
          
           // this.value=  json.value.lenght>0 ? json.value.split(',') : [];
           // this.value=  json.value;

        }
    },
    computed: {
        listRules() {
            return this.ayar.rules.map(m => rules[m]);

        },

        getAyar: function () {
            // `this` points to the vm instance
            return this.ayar;
        },
        getStoreItems: function () {
            let itemListesi = [];

            if (!this.trigger) {
                console.log("getStoreItems2", this.store);
                this.store.forEach(m => {
                    //itemListesi.push(({ id: m, name: m }));
                    itemListesi.push(m);

                })



            }
            else {

                itemListesi = this.store.map(item => {
                    let index = item.name.indexOf("::");
                    if (index > -1) {
                        let value = item.name.substring(0, index);
                        return { id: value, name: value };
                    }
                    return item;
                })
                itemListesi = [...new Set(itemListesi.map(item => item.name))];
                // this.store.forEach(m => {
                //     let parentData = m.name.split("::");
                //     itemListesi.push(({ id: parentData[1], name: parentData[1], parent: parentData[0] }));

                // })
            }
            return itemListesi;
        },
        // iç kullanım için modelValue (opsiyonel)
        model: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val); // v-model'e değer gönder
            }
        }

    },
    created() {
        this.dataBind(this.ayar);
        //console.log("Created Value:",this.ayar.value.length);
        console.log("CHDC",this.ayar.value);
        if (this.ayar.value){
                this.value=  this.ayar.value.length>0 ? this.ayar.value.split(',') : [];
        }
        else
        {
            this.value=[];
        }
    
    },
    watch: {
        value(x, y) {
            this.$emit('input', x);
            //console.log("Rules",x,y);
        },
        ayar: {
            immediate: true,
            handler(newVal, oldVal) {
                // console.log("handler:",newVal);
                // if  (newVal.required){
                // newVal.rules.push(value => !!value || 'Bu alana boş bırakılamaz.')
                // }

                this.dataBind(newVal);
                //this.slots.forEach(slot => {
                //    if (slot.availability > 10) slot.availability = 10;
                //});
            },
            deep: true
        }

    },

}
</script>
<style scoped>
.pasifCard{
  background-color: gray !important;
}
</style>